import { useTranslation } from 'react-i18next';

/**
 * Production hostname. Anything else (dev.poke-me.sh, localhost, preview
 * deploys, ad-hoc tunnels, the legacy push-me.* aliases) is treated as a
 * non-production environment and gets a visible badge in the top-right
 * corner. Detected at runtime so the same SPA bundle ships to every
 * target.
 */
const PROD_HOST = 'poke-me.sh';

function currentHost(): string | null {
  if (typeof window === 'undefined') return null;
  return window.location.host;
}

export function EnvironmentBadge() {
  const { t } = useTranslation('common');
  const host = currentHost();
  if (host === null || host === PROD_HOST) return null;

  return (
    <div
      role="status"
      aria-label={t('env.badgeLabel')}
      className="pointer-events-none fixed right-3 top-3 z-50 select-none rounded-full border border-amber-400 bg-amber-100/95 px-2.5 py-1 font-mono text-xs font-medium text-amber-900 shadow-sm dark:border-amber-600 dark:bg-amber-900/80 dark:text-amber-100"
    >
      {host}
    </div>
  );
}
